import { ImportExportApiService } from 'src/app/data-transfer/services/import-export-api-service';
import { ImportTypeSetting, PackagingImportHelper } from './packaging-import-helper';
import { MaterialNavigationService } from 'src/app/navigation/services/navigation-services/material-navigation.service';
import { Observable } from 'rxjs';
import { ImportCandidateDto } from 'src/app/data-transfer/entities/import-candidate-dto';
import { ChangeCandidateDto } from 'src/app/data-transfer/entities/change-candidate-dto';
import { ChangeMaterialCandidateDto } from 'src/app/data-transfer/entities/material-entities/change-material-candidate-dto';

export class PackagingMaterialImportHelper implements PackagingImportHelper {
  constructor(
    private importExportApiService: ImportExportApiService,
    private materialNavigationService: MaterialNavigationService
  ) {}

  getTableTitle(importType: ImportTypeSetting, archiveActive: boolean): string {
    if (importType === ImportTypeSetting.Import) {
      if(archiveActive) {
        return 'dataManagement.import.import.tableTitleMaterialArchive';
      }
      return 'dataManagement.import.import.tableTitleMaterial';
    }
    return 'dataManagement.import.changes.tableTitleMaterial';
  }

  getDisplayedColumns(): string[] {
    return ['itemId', 'version', 'exportingOrganization', 'articleName', 'articleNumber', 'timestamp', 'action', 'select'];
  }

  getPackagingImportCandidates(): Observable<ImportCandidateDto[]> {
    return this.importExportApiService.getMaterialImportCandidates();
  }

  getPackagingChangeCandidates(): Observable<ChangeCandidateDto[]> {
    return this.importExportApiService.getMaterialTrackedChanges();
  }

  getDeleteFunction(importType: ImportTypeSetting): (candidate: number) => Observable<any> {
    if (importType === ImportTypeSetting.Import) {
      return this.getDeleteFunctionImportCandidate();
    }
    return this.getDeleteFunctionChangeCandidate();
  }

  getImportFunctionImportCandidate(): (candidateId: number, targetDirId: number, isWithTracking: boolean) => Observable<any> {
    return (candidateId: number, targetDirId: number, isWithTracking: boolean) => this.importExportApiService.importMaterials(candidateId, targetDirId, isWithTracking);
  }

  getChangeFunctionChangeCandidate(): (changeId: number) => Observable<any> {
    return (changeId: number) => this.importExportApiService.applyMaterialChanges(changeId);
  }

  getPackagingIdsFromChangeCandidates(selectedChanges: ChangeCandidateDto[]): number[] {
    return selectedChanges.map(x => (x as ChangeMaterialCandidateDto).existingMultiMaterial.id ?? -1).filter(x => x !== -1);
  }

  navigateToCandidate(candidate: ImportCandidateDto): void {
    this.materialNavigationService.navigateToMaterialPreview(candidate.id);
  }

  navigateToChange(candidate: ChangeCandidateDto, seePackagingBeforeChange: boolean): void {
    const change = candidate as ChangeMaterialCandidateDto;
    const id = seePackagingBeforeChange ? change.existingMultiMaterial.id : change.importCandidateId;
    if (id == null) {
      return;
    }
    this.materialNavigationService.navigateToMaterialPreview(id, true, seePackagingBeforeChange);
  }

  private getDeleteFunctionImportCandidate(): (candidate: number) => Observable<any> {
    return (candidateId: number) => this.importExportApiService.deleteMaterialImportCandidate(candidateId);
  }

  private getDeleteFunctionChangeCandidate(): (candidate: number) => Observable<any> {
    return (changeId: number) => this.importExportApiService.ignoreMaterialChanges(changeId);
  }
}
